import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { selectVehicle } from '../../../selectors';
import { Loader } from '../../../../../components/Loader';
import { selectWorks } from '../../../../Api/selectors';
import { createVehicleWithProps } from '../../../actions';
import { REQUEST_VEHICLE } from '../../../constants';
import { VehicleCreateField } from './Fields';
import { render } from 'react-dom';
import cn from 'classnames';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import styles from './SixtStep.module.css';
import env from '../../../../../env';

const Container = styled.div`
  width: 100%;

  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;

    @media (max-width: 768px) {
      padding-right: 0;
      min-width: 300px;
      width: 100%;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }
`;

const STATE = {};

class VehicleCreateStep6Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }



  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
   
    //console.log('this.props', this.props.createdVehicle);
    const vehicle = this.props.createdVehicle;
    if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.container}>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <HBox flip={window.innerWidth < 768} className={styles.wrapper}>
              <div className={styles.containerFlex}>
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.missing_fields')}</h2>
                {
                    (() => {
                      let requiredFields;

                      if (vehicle?.vehicle_purpose === 'commercial') {
                        if (vehicle?.fuel_type === 'electric' || vehicle?.fuel_type === 'elektrisch') {
                          requiredFields = [
                            ...env.requiredFieldsCommercial.map(field => field.toLowerCase()),
                            ...env.requiredFieldsElectric.map(field => field.toLowerCase())
                          ];
                        } else {
                          requiredFields = env.requiredFieldsCommercial.map(field => field.toLowerCase());
                        }
                      } else if (vehicle?.vehicle_purpose === 'passenger') {
                        if (vehicle?.fuel_type === 'electric' || vehicle?.fuel_type === 'elektrisch') {
                          requiredFields = [
                            ...env.requiredFieldsPersonal.map(field => field.toLowerCase()),
                            ...env.requiredFieldsElectric.map(field => field.toLowerCase())
                          ];
                        } else {
                          requiredFields = env.requiredFieldsPersonal.map(field => field.toLowerCase());
                        }
                      }

                      return (requiredFields || []).map(type => (
                        <VehicleCreateField
                          key={type}
                          type={type}
                          creditorInfo={this.props.creditorInfo}
                        />
                      ));
                    })()
                  }

              </div>
            </HBox>

            <div className="d-flex gap-2 justify-content-end mt-2">
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
                {this.lbl('previous')}
              </ButtonComponent>

              <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)}>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

VehicleCreateStep6Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    createdVehicle: selectVehicle(ownProps.vehicle_id),
    work: selectWorks([REQUEST_VEHICLE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep6 = compose(withConnect, withRouter)(VehicleCreateStep6Comp);
